import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cfac549"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-bar" }
const _hoisted_2 = { class: "notice-btn" }
const _hoisted_3 = { class: "notice-text" }

interface Props {
  name?: string
  phone?: string
  state?: string
}


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'WidgetServer' },
  __name: 'widget-server',
  props: {
    name: { default: '汪经理' },
    phone: { default: '13588794526' },
    state: { default: '客服服务' }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_widget_card = _resolveComponent("widget-card")!

  return (_openBlock(), _createBlock(_component_widget_card, { spacing: "1rem" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.state), 1),
        _createElementVNode("span", _hoisted_3, "如有问题，请联系您的专属客服" + _toDisplayString(_ctx.name) + "（" + _toDisplayString(_ctx.phone) + "）为您服务", 1)
      ])
    ]),
    _: 1
  }))
}
}

})